import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle, RefreshCw } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export default function BillingSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    // Redirect to billing page with session_id for status polling
    if (sessionId) {
      setTimeout(() => {
        navigate(`/dashboard/billing?session_id=${sessionId}`, { replace: true });
      }, 2000);
    } else {
      navigate("/dashboard/billing", { replace: true });
    }
  }, [sessionId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-emerald-50 to-white p-6">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 text-center space-y-4">
          <div className="w-16 h-16 mx-auto bg-emerald-100 rounded-full flex items-center justify-center">
            <CheckCircle className="w-8 h-8 text-emerald-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900">Payment Successful!</h1>
          <p className="text-slate-600">
            Thank you for your subscription. Your account is being activated...
          </p>
          <div className="flex items-center justify-center gap-2 text-slate-500">
            <RefreshCw className="w-4 h-4 animate-spin" />
            <span>Redirecting to your dashboard...</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
